// extracted by mini-css-extract-plugin
export var compactFilters = "_cj-4";
export var detailImage = "_cj-1";
export var dropdownContainer = "_cj-2";
export var imageContainer = "_cj-0";
export var selectedCard = "_cj-3";